import { lazy } from 'react';

const MeetingNoteModal = lazy(() => import('./modals/MeetingNoteModal'));
const RenameDocumentModal = lazy(() => import('./modals/RenameDocumentModal'));

export default {
  MEETING_NOTE_MODAL: MeetingNoteModal,
  RENAME_DOCUMENT_MODAL: RenameDocumentModal,
};
